import React, { memo } from 'react';
import { Tooltip } from 'react-bootstrap';

import { useStore } from 'src/modules/users/hooks/useStore';

import { StoreContext } from '../store';

export const ForbidDeleteCardTooltip = memo<{ isRoot: boolean }>(({ isRoot }) => {
  const store = useStore(StoreContext);

  if (store.cardsList?.length === 1) return <Tooltip id="tooltip">Нельзя удалить единственный способ</Tooltip>;
  if (isRoot) return <Tooltip id="tooltip">Для удаления измените основной способ оплаты</Tooltip>;
  return null;
});
